// hooks/useCssVar.js
import { useMemo } from "react";

export function useCssVar(name) {
	return useMemo(() => {
		let raw = getComputedStyle(document.documentElement)
			.getPropertyValue(name)
			.trim();

		// kalau hasilnya "url('...')" → ambil isi dalamnya saja
		if (raw.startsWith("url(")) {
			raw = raw.replace(/^url\((['"]?)(.*)\1\)$/, "$2");
		}

		return raw;
	}, [name]);
}
